export enum EFirebaseParams {
    ACCOUNTING_BUYERS = 'accounting_buyers',
    INTEGRATIONS_ENABLED = 'buyer_integrations_enabled',
    LIST_OF_BUYER_ACCOUNTING_INTEGRATIONS = 'list_of_buyer_accounting_integrations',
    OFFLINE_INVOICES_BUYERS = 'offline_invoices_buyers',
    BUYER_BUSHWHACK_ENABLED = 'buyer_bushwhack_enabled',
    DUAL_SYNC_ENABLED = 'dual_sync_integrations_buyers'
}
